export default {
  common: {
    label_fr:"francais",
    label_en:"english",
    label_es:"spanish",
    labelActions55:"Actions 5•5",
    labelCollections55:"Collections 5•5",
    labelClassics:"Clásicos",
    labelCreateYourModel: "Crear mi modelo",
    labelPreviousProject: "Proyecto anterior",
    labelNextProject:"Proyecto siguiente",
    footerLegals:"Menciones legales",
    footerOberSurfacesBrand:"Una marca de Ober Surfaces",
    footerPageOnTop:"Principio de la pagina",
    LabelOpenProject:"Ver el proyecto",
    realisationsBackbutton:"Volver a las realizaciones",
    labelArchitect:"Arquitecto",
    labelDesign:"Conception",
    labelPattern:"Motivo",
    labelSurface:"Superficie",
    cancelButton: "Anular",
    submitButton: "Validar",
    createButton: "Crear",
    saveButton: "Guardar",
    deleteButton: "Suprimir",
    continueButton: "Continuar",
    newFolder: "Nueva Carpeta"



  },
  layout: {
    myaccount: "Mi cuenta",
    mymodels: "Mis modelos",
  },
  menu: {
    menuCreate:"Crear mi modelo",
    menuAbout:"A cerca de",
    menuCollections:"Colecciones",
    menuRealisations:"Realizaciones",
    menuContact:"Contacto",
    menuSupport:"Preguntas"
  },
  header: {
  },
  footer: {
    newProjectLabel: "Nueva carpeta"
  },
  realisations: {
    internationalInstitution:"Institución Internacional",
    ministryOfForeignAffairs:"Ministerio de asuntos exteriores"
  },
  collections: {
    titleSurfaces: "Las Superficies",
    titlePatterns: "Los Motivos",
  },
  collectionsList: {
    titleSurfaces: "Las Superficies",
    titlePatterns: "Los Motivos",
    pageintroduction1: "Descubra el conjunto de las colecciones",
    pageintroduction2: "en las páginas web de nuestras marcas.",
    oberflexDescription: "La elegancia de la madera natural asociada a la alta resistencia de superficie Oberflex; una tecnicidad incomparable para una aplicación en los proyectos los mas exigentes.",
    marotteDescription: "Chapas de madera tintadas en su masa para sublimar la intensidad de los colores y la delicadeza de las venas.",
    purepaperColorDescription: "Una colección de superficies decorativas de 25 colores cuidadosamente seleccionadas, extra mates y de una profundidad parecida a la del papel secante.",
    purepaperMetalDescription: "Las tonalidades de cobre, inox, estaño, alu, o de cañon de fusil componen una paleta de 11 superficies metálicas con aspectos cepillados, brillantes o brutos."
  },
  patternsList: {
    titleSurfaces: "Las Superficies",
    titlePatterns: "Los Motivos",
    action55Description: "La nueva colección de paneles acústicos personalizables, 6 modelos a configurar para crear una infinidad de motivos perforados.",
    collections55Description: "Cinco colecciones, imaginadas por el Studio 5•5. En cada colección cinco motivos que se transforman en piel de arquitectura, vestido de espacio, pared vegetal, panel vibrante o paisaje verdadero.",
    classicsDescription: "La colección de los básicos para una integración discreta. Perforaciones redondas, oblongas o invisibles con la tecnología de la microperforación.",
    discoverbutton:"Descubrir la gama",

  },
  about: {
    pageDescription1:"Obersound es un concepto de paneles acústicos imaginado",
    pageDescription2:"y desarrollado por el Studio collectif 5•5 para Ober Surfaces,",
    pageDescription3:"fabricante de soluciones decorativas y técnicas para la decoración interior.",

    obersurfacesDescription1:"Motivado por valores de innovación y de eco-concepción, Ober Surfaces propone a través de sus marcas Oberflex, Marotte, Pure Paper y Staron, una selección amplia de superficies decorativas para la decoración interior. La empresa entretiene su capacidad de reacción a la demanda, anticipa sin parar el deseo de novedades y hace todo lo posible para satisfacer las exigencias de la creación.",
    obersurfacesDescription2:"Este dinamismo creativo lleva también Ober Surfaces a dirigirse hacia colaboradores exteriores y a crear colecciones con arquitectos y diseñadores. Hoy esta política continua con la intervención del Studio 5.5 para imaginar nuevas modalidades de perforaciones acústicas.",
    obersurfacesDescription3:"El conjunto de las soluciones estéticas, técnicas y acústicas se encuentran en ober-surfaces.com",
    studio55Description1:"5•5 es un estudio colectivo de diseño global creado en 2003 por Vincent Baranger, Jean-Sébastien Blanc, Anthony Lebossé y Claire Renard después de estudiar à l'Ecole Nationale Supérieure des Arts Appliqués.",
    studio55Description2:"Hoy, este pequeño colectivo se ha transformado en un estudio pero sin cambiar su filosofía. Celebrando desde su creación, la colaboración de individuos dentro de un ambiente alegre, el Studio 5•5 reúne naturalmente talentos creativos pluridisciplinarios dentro de su enfoque de diseño global. Ahora los 5•5 animan una estructura capaz de acompañar a sus clientes con las mismas convicciones que las de sus principios: siempre mantenerse cerca de la gente, proponiendo cosas útiles y que proporcionan inspiración para alegrar nuestro cotidiano.",
  },
  support: {
    titleTechnicalQuestion:"Preguntas técnicas",
    titleBusinessQuestion:"Preguntas comerciales",
    titleAcousticQuestion:"Preguntas acústicas"
  },
  supportTechnical: {

    question1:"¿Para qué sirven los tableros Obersound?",
    boldWords1:"tableros",
    answer1:"Los paneles Obersound sirven a mejorar la calidad acústica de un espacio interior. Instalados en las paredes o en el techo, absorban una parte de la onda sonora y limitan su reverberación.",

    question2:"¿Cuál es la composición de un tablero Obersound?",
    boldWords2:"composición",
    answer2:"El panel Obersound está compuesto de un alma en MDF, revestido de una superficie decorativa de  madera, de color liso o de metal, y de un compensador. Una vez perforado, la contracara esta revestida de un velo negro.",

    question3:"¿Cuáles son los formatos de los tableros Obersound?",
    boldWords3:"formatos",
    answer3:"Los tableros Obersound son disponibles en formatos estándar de 2490X1200 o 3000X1200 mm. También se pueden fabricar a medida, según un plano y un listado de cortes.",

    question4:"¿Cómo se acaban  los cantos de los tableros Obersound?",
    boldWords4:"cantos de los tableros",
    answer4:"Los cantos de los tableros Obersound pueden ser aplacados con las bandas a juego de la cara decorativa.",

    question5:"¿Cómo instalar los tableros Obersound?",
    boldWords5:"instalar",
    answer5:"Los tableros Obersound se instalan como los tableros tradicionales. El instalador cualificado elige el sistema de fijación adecuado a las particularidades del proyecto. Para una absorción optima, se recomienda la instalación de una lana de roca detrás de los tableros.",

    question6:"¿El modelo que he configurado se puede aplicar en un techo?",
    boldWords6:"techo",
    answer6:"Los paneles acústicos Obersound han sido creados para ser instalados en el techo o en la pared. El servicio de atención al cliente Ober Surfaces le puede orientar sobre los formatos los mas adecuados y sobre el tipo de instalación que varía en función de cada proyecto.",

    question7:"¿Se puede utilizar tableros del mismo acabado pero sin perforación para completar el proyecto (puertas, zócalos..)?",
    boldWords7:"tableros",
    boldWords7_1:"sin perforación",
    answer7:"Para poder fabricar puertas, zócalos, mobiliario, los tableros no perforados y las láminas son disponibles en todas las superficies propuestas por el configurador Obersound.",

    question8:"¿Quien realiza el estudio acústico del proyecto?",
    boldWords8:"el estudio acústico",
    answer8:"El arquitecto, en colaboración con un ingeniero acústico, realiza las prescripciones acústicas del proyecto.",

    question9:"Los formatos estándar de los paneles no son adecuados à mi proyecto. Generan demasiada merma. ¿Como se puede solucionar?",
    boldWords9:"formatos estándar de los paneles",
    answer9:"A lo largo del proceso de elaboración del proyecto, el Servicio de Atención al Cliente Ober Surfaces puede estudiar sus planos y proponer soluciones adaptadas: paneles a medida, mejora del rendimiento...",

  },
  supportBusiness: {
    question1:"¿Cómo saber el precio de un modelo que he configurado?",
    boldWords1:"precio",
    answer1:"El servicio cliente Ober Surfaces está a su disposición para enviarle el precio del modelo que ha configurado. El precio/m² de los tableros Obersound varía según el tipo de superficie y de la perforación.",

    question2:"¿Cuál es el plazo de fabricación de los tableros Obersound?",
    boldWords2:"plazo",
    answer2:"Cada panel Obersound es único y especialmente fabricado según las opciones propuestas por el configurador. Habitualmente el plazo es de 4 a 5 semanas, salvo casos particulares.",

    question3:"¿Qué informaciones tengo que dar para recibir un presupuesto?",
    boldWords3:"informaciones",
    answer3:"El servicio de atención al cliente Ober Surfaces estudia un precio tomando en cuenta la ficha técnica del producto configurado, de las dimensiones y de las cantidades deseadas. Puede recomendarle opciones como la mecanización de los cantos, calificación al fuego, perfiles de instalación, etc.",

    question4:"¿Se puede utilizar tableros del mismo acabado pero sin perforación para completar el proyecto (puertas, zócalos..)?",
    boldWords4:"tableros",
    boldWords4_1:"sin perforación",
    answer4:"Para poder fabricar puertas, zócalos, mobiliario, los tableros no perforados y las láminas son disponibles en todas las superficies propuestas por el configurador Obersound.",

    question5:"¿Quien realiza el estudio acústico del proyecto?",
    boldWords5:"el estudio acústico",
    answer5:"El arquitecto, en colaboración con un ingeniero acústico, realiza las prescripciones acústicas del proyecto.",

    question6:"Necesito enseñar a mi cliente un prototipo del modelo configurado. ¿Puede ser?",
    boldWords6:"prototipo del modelo configurado",
    answer6:"Si, solo tiene que pedirlo al Servicio de Atención al cliente para recibir un presupuesto del prototipo. También tenemos muestras de los modelos estándar.",

    question7:"¿Puedo pedir una muestra de la superficie elegida del modelo que he configurado?",
    boldWords7:"muestra",
    answer7:"Si, solo tiene que pedirla al Servicio de Atención al Cliente.",

    question8:"Los formatos estándar de los paneles no son adecuados à mi proyecto. Generan demasiada merma. ¿Como se puede solucionar?",
    boldWords8:"formatos estándar de los paneles",
    answer8:"A lo largo del proceso de elaboración del proyecto, el Servicio de Atención al Cliente Ober Surfaces puede estudiar sus planos y proponer soluciones adaptadas: paneles a medida, mejora del rendimiento..."
    },

  supportAcoustic: {
    question1:"¿Cómo interpretar los valores acústicos disponibles en el configurador Obersound?",
    boldWords1:"acústicos disponibles",
    answer1:"La gestión correcta de la acústica de un local no pasa siempre por una absorción máxima. La curva ilustra el nivel de absorción en función de las frecuencias.",

    question2:"¿Hay que elegir siempre los modelos Obersound los más absorbentes?",
    boldWords2:"los más absorbentes",
    answer2:"La evaluación del nivel de absorción el más adecuado se hace según varios criterios como : la función de local (recepción, restaurante, oficinas..), su configuración o la presencia de otros materiales acústicos.",

    question3:"¿Quien realiza el estudio acústico del proyecto?",
    boldWords3:"el estudio acústico",
    answer3:"El arquitecto, en colaboración con un ingeniero acústico, realiza las prescripciones acústicas del proyecto."
    },

  home: {
    page2Action55Description: "La nueva colección de paneles acústicos personalizables",
    page3Description: "6 modelos a configurar para crear una infinidad  de motivos perforados",
    page4Description: "Una nueva herramienta para explorar el conjunto de soluciones acústicas Obersound a combinar con las colecciones Ober Surfaces®",
    page4Step1Title:"Cree sus modelos con la ayuda del configurador",
    page4Step1Description:"Elige sus motivos y combínelos con más de 160 superficies diferentes",
    page4Step2Title:"Constituya su materiateca",
    page4Step2Description:"Organiza sus creaciones dentro de una biblioteca personal.",
    page4Step3Title:"Descargue sus modelos & fichas técnicas",
    page4Step3Description:"Descargue sus imágenes HD y informaciones técnicas.",
    page5Title:"Empiece su experiencia y encuentre todas les soluciones Obersound.",
    page5Pattern1Description:"La nueva colección de paneles acústicos personalizables, 6 modelos a configurar para crear una infinidad de motivos perforados.",
    page5Pattern2Description:"Cinco colecciones, imaginadas por el Studio 5•5. En cada colección cinco motivos que se transforman en piel de arquitectura, vestido de espacio, pared vegetal, panel vibrante o paisaje verdadero.",
    page5Pattern3Description:"La colección de las perforaciones básicas para una integración discreta. Perforaciones redondas, oblongas o invisibles con la tecnología de la microperforación.",
  },
  terms: {
    titleTerms:"Aviso legal",
    textTerms:"El acceso, el uso y la conexión a este sitio conllevan la aceptación plena y sin reservas de las presentes modalidades de utilización.",
    title1:"1. Informaciones legales",
    text1_1:"El sitio www.obersound.com que consulta en este momento es titularidad de:",
    text1_2:"OBER&lt;br/&gt;31 rue de Bar, 55000 Longeville en Barrois&lt;br/&gt;France&lt;br/&gt;T : +33 3 29 76 77 78&lt;br/&gt;obercom@ober-surfaces.com&lt;br/&gt;&lt;br/&gt;S.A. cuyo capital asciende a 2.061.509 €&lt;br/&gt;Registro Mercantil de Bar le Duc - B 382 745 404&lt;br/&gt;N° de IVA intracomunitario: FR 82 382 745 404&lt;br/&gt;",
    text1_3:"Director de la publicación: Etienne de la Thébeaudière &lt;br/&gt;El presente sitio está alojado por Firebase, 188 King ST, San Francisco, CA 94107, Estados-Unidos, https ://firebase.google.com/. &lt;br/&gt;El presente sitio ha sido concebido por studio 5&#8226;5, 8, rue Popincourt - 75011 PARIS, Francia&lt;br/&gt;El presente sitio ha sido desarrollado por la compañía Sensology, 21, rue Trévise -75009 PARIS, Francia&lt;br/&gt;",
    title2:"2. Datos personales",
    text2_1:"Recabamos datos personales con la información que solicitamos cuando se da de alta en nuestro sitio o se conecta a su cuenta.",
    text2_2:"La información que recabamos puede ser utilizada a los fines a continuación:&lt;br/&gt;- Contestar a sus solicitudes dentro del marco de la relación comercial entre usted y Ober, nuestra sociedad.&lt;br/&gt;- Mejorar nuestro sitio Web.&lt;br/&gt;- Contactar con usted mediante email o vía telefónica.&lt;br/&gt;- Informarle de nuestra actualidad mediante newsletters.",
    text2_3:"En cumplimiento de lo establecido en el Reglamento Nº2016/679 (UE) del Parlamento Europeo y del Consejo, relativo a la Protección de Datos, de fecha 27 de abril (en adelante, ''RGPD''), usted podrá ejercer sus derechos de acceso, rectificación, cancelación/supresión, oposición, limitación o portabilidad de sus datos personales mediante email a: obercom@ober-surfaces.com",
    text2_4:"Ober se compromete de manera expresa a no divulgar dichas informaciones a terceros.",
    title3:"3. Cookies",
    text3_1:"Las cookies son pequeños archivos de texto que se instalan en su ordenador o periférico cuando visita nuestro sitio, con el fin de que sus visitas sean más eficientes. Nos permiten, igualmente, mejorar la navegación.",
    text3_2:"Utilizamos las cookies a los siguientes efectos:&lt;br/&gt;- Memorizar su información de conexión.&lt;br/&gt;- Identificarle cuando se conecta a nuestro sitio.&lt;br/&gt;- Recabar información analítica para, por ejemplo, contar el número de visitas realizadas a nuestro sitio e identificar las páginas que se visitan con más frecuencia.",
    title4:"4. Propiedad intelectual",
    text4_1:"El acceso al sitio www.obersound.com le confiere un derecho de uso privado y no exclusivo de dicho sitio.",
    text4_2:"Todos los artículos, fotografías y demás documentos de este sitio son titularidad de Ober, o se utilizan mediante el consentimiento de sus titulares, y se someten a los derechos de autor y demás derechos de propiedad intelectual. Se prohíbe toda reproducción y /o representación, ya sea total o parcial, de los contenidos del presente sitio sin la autorización previa, expresa y por escrito de Ober.",
    text4_3:"Se prohíbe rotundamente el uso fraudulento de todo contenido del sitio www.obersound.com. Ober le informa que ejercerá plenamente sus derechos de propiedad intelectual a los efectos de instar procedimientos judiciales, incluso penales si necesario.",
    title5:"5. Condiciones de utilización",
    text5_1:"La sociedad Ober trata de garantizar la exactitud y la actualización constante de la información difundida en este sitio. Se reserva el derecho de corregir o modificar su contenido en todo momento y sin preaviso.",
    text5_2:"La información contenida en el presente sitio (fichas técnicas, ilustraciones, imágenes u otros elementos) no es de naturaleza contractual.",
    text5_3:"Ober tratará de garantizar la accesibilidad del sitio a los usuarios en todo momento. Ober no será responsable de la indisponibilidad del sitio cualquiera que sea el motivo.",
    title6:"6. Limitación de responsabilidad",
    text6_1:"Usted utiliza y navega por este sitio bajo su responsabilidad exclusiva. Ni Ober ni ningún tercero involucrado en la creación, la producción o la implementación del presente sitio podrán ser responsables de los daños directos, indirectos, accidentales, consecutivos u otros, derivados de su acceso al sitio o de su uso, incluyendo, sin restricción, toda pérdida de disponibilidad, pérdida de datos o interrupción de la actividad.",
    text6_2:"Igualmente, Ober no podrá ser responsable de los daños o virus susceptibles de ser causados o de infectar su equipo informático u otro material, ni de las pérdidas o alteraciones de datos derivadas de su acceso a este sitio o las descargas realizadas en el mismo. En ningún caso la responsabilidad global de Ober, cualquiera que sea su fundamento, podrá ser superior a la cuantía abonada por usted para acceder al presente sitio.",
    text6_3:"Ober tratará de garantizar la accesibilidad del sitio a los usuarios en todo momento. Ober no será responsable de la indisponibilidad del sitio cualquiera que sea el motivo.",
    title7:"7. Contacto",
    text7_1:"Para contactar con nosotros mediante email: obercom@ober-surfaces.com"

  //   &lt;br/&gt;
},
  contact: {
    contactTitle: "Contáctenos",
    firstname:"Apellido*",
    name:"Nombre*",
    company:"Empresa*",
    activity:"Profesión*",
    address:"Dirección*",
    postCode:"Código postal*",
    city:"Ciudad*",
    country:"País*",
    phoneNumber:"Teléfono *",
    job:"Cargo*",
    emailAdress:"Correo electrónico*",
    subjectMessage:"Objeto de su mensaje*",
    yourMessage:"Su mensage*",
    sendButton:"Validar",
    fieldsRequired:"* Datos obligatorios",

    messageSending:"Envoi en cours",
    messageSent:"Votre message a bien été envoyé.",
    mapLanguage:"es",
    headOffice:"Sede social",

    aaa:"",
    aaab:""
  },
  signup:{
    civility:"wazzaa",
    disconnect:"Desconectarse",

    aaaq:"",
    aaas:""
  },
  signin:{
    connect:"Conectarse",
    introPage:"Tiene que conectarse a su cuenta <br/>para <span class='font-bold'>guardar</span> y <span class='font-bold'>descargar</span> sus modelos.",
    noaccount:"Nuevo cliente ?",
    identify:"Identificarse",
    connectButton:"Conectarse",
    inscriptionButton:"Me inscribo",
    emailAdressTextfield:"Correo electrónico",
    passwordTextfield:"Contraseña",
    forgottenPassword:"Contraseña perdida o olvidada",
    //my account
    disconnect:"Cerrar sesión",
    deleteAccount:"Borrar mi cuenta",
    newPasswordSign:"Nueva contraseña*",
    newPasswordConfirmSign:"Repetir nueva contraseña*",
    emptyLabel:"Laisser vide si mot de passe non modifié",

  },
  userActivities:{
      activity0title: "Profesión", // (not used anymore) Marques localisation => i18n
      activity1title: "Arquitecto",
      activity2title: "Interiorista",
      activity3title: "Diseñador",
      activity4title: "Oficina Técnica",
      activity5title: "Constructora",
      activity6title: "Promotor",
      activity7title: "Carpintero / Instalador",
      activity8title: "Aparejador",
      activity9title: "Ingeniero acústico",
      activity10title: "Industrial",
      activity11title: "Propiedad de obra",
      activity12title: "Otro"
  },
  modals:{
    modifyMyFolder:"Modificar mi archivo",
    deleteFolderConfirmation:"Esta segura que quiere suprimir esta carpeta?",
    deleteModelConfirmation: "Esta segura que quiere suprimir este modelo?",
    deleteAccountConfirmation: "Esta segura que quiere suprimir este cuento?",
    shareModelTitle:"Compartir esta composición",
    shareModelText:"Compartir el URL de su composición:",
    shareModelCopyText:"Copiar",
    shareModelCopiedText:"Copiado",
    downloadModalTitle:"Descargar",
    downloadModalHDfile:"Imagen HD",
    downloadModalExportButton:"Exporter",
    downloadModalProductPerforatedSurface:"Superficie perforada",
    downloadModalProductNonPerforatedSurface:"Superficie sin perforación",
    downloadModalProductPageButton:"Ficha técnica ",
    downloadModalGenerateButton:"Generar",
    downloadModalDownloadButton:"Descargar",
    acousticPerformanceTitle:"Rendimiento acústico",

    welcomeModelTitle: "¡Bienvenido en la página « mis modelos »!",
    welcomeModelText1: "Este espacio le permite guardar y descargar sus modelos. Podrá organizar, modificar y suprimir sus creaciones en cualquier momento.",
    welcomeModelText2: "Para acceder a esta página, clique sobre « mis modelos », situado a la derecha de la barra de navegación.",

    addToExistingFolder:"Añadir a una carpeta existente",
    createNewFolder:"Crea un archivo para guardar mi modelo",
    exArchitectForm:"Ejemplo: Arquitecto diverso"


  },
  account:{
    inscriptionPageTitle:"Inscription",
    civilitySign:"Civilité* :",
    civilityMrSign:"M.",
    civilityMrsSign:"Mme",
    lastNameSign:"Nom*",
    firstNameSign:"Prénom*",
    companyNameSign:"Entreprise*",
    addressSign:"Adresse*",
    citySign:"Ville*",
    postCodeSign:"Code postal*",
    countrySign:"Pays*",
    emailAddressSign:"Votre e-mail*",
    emailAddressConfirmSign:"Confirmation de votre e-mail*",
    passwordSign:"Votre mot de passe*",
    passwordConfirmSign:"Confirmation de votre mot de passe*",
    requiredSign:"* Datos obligatorios"
  },
  pdf:{
        pdfLoading:"Cargando...",
        pdfLogoTitle:"Soluciones acústicas",
        pdfProductSpec:"Ficha producto",
        pdfProductRef:"Referencia :",
        pdfLabelName:"Apellido :",
        pdfLabelCompany:"Empresa :",
        pdfLabelFolderName:"Nombre de la carpeta :",
        pdfLabelDate:"Fecha :",
        pdfLabelDescription:"Descripción",
        pdfLabelMaker:"Fabricante :",
        pdfLabelSurface:"Superficie :",
        pdfLabelAcousticPerformance:"Perforación acústica",
        pdfLabelSupport:"Soporte :",
        pdfLabelSupportMDF16:"MDF natural 16 mm",
        pdfLabelContreface:"Contracara :",
        pdfLabelContrefaceVoileNoir: "Velo negro",
        pdfLabelSize:"Formatos :",
        pdfLabelSizeContent:"estándar 2490 x 1220 mm o a medida",
        pdfLabelThickness:"Espesor :",
        pdfLabelFireClassification:"Clasificación al fuego :",
        pdfLabelSurfaceResistance:"Resistencia de surperficie :",
        pdfLabelSurfaceResistanceNorme:"conforme con la norma EN438",
        pdfLabelRegisteredDesign: "Modelo registrado Obersound",
        pdfLabelCustomSizes: "Formatos a medida según un plano y un listado de cortes",
        pdfLabelNB : "Superficies sin perforación disponibles. Consúltenos.",
        pdfLabelAcouticPerf: "Rendimiento acústico",
        pdfLabelAcouticPerfAw: "\u03b1w :",
        pdfLabelPerforationRate: "Tasa de perforación :",
        pdfLabelAvailableSoon: "Ensayo acústico disponible pronto",
        pdfLabelMakerContact: "Contacto fabricante",
        pdfLabelTechnicalSupport: "Apoyo técnico :",
      },
  editor:{
    introCreatePage:"Seleccionar una superficie </br>o un motivo para empezar.",

    leftPanelSurfacesTitle:"Superficies",
    RightPanelPatternsTitle:"Motivos",

    SurfacesFilter:"Filtrar mi busqueda",
    SurfacesChange:"Cambiar mi busqueda",
    noSearchResult:"Ningún resultado corresponde a su búsqueda.",
    diameterLabel:"Diámetro",
    entraxeLabel:"Entreeje",

    brandIdFilter:"Marcas:",
    brandIdFilterTitle1:"Oberflex",
    brandIdFilterTitle2:"Marotte",
    brandIdFilterTitle3:"Pure Paper Color",
    brandIdFilterTitle4:"Pure Paper Métal",

    typeIdFilter:"Tipos:",
    typeIdFilterTitle2:"Laminados de madera",
    typeIdFilterTitle3:"Madera barnizada",
    typeIdFilterTitle1:"Colores",
    typeIdFilterTitle4:"Metal",

    shadeIdFilter:"Matices:",
    shadeIdFilterTitle1:"Claro",
    shadeIdFilterTitle2:"Medio",
    shadeIdFilterTitle3:"Oscuro",

    collectionIdFilter:"Colecciones:",
    collectionIdFilterTitle1:"Actions 5•5",
    collectionIdFilterTitle2:"Collections 5•5",
    collectionIdFilterTitle0:"Clásicos",

    absorptionIdFilter:"Absorción acústica:",
    absorptionIdFilterTitle1:"Media",
    absorptionIdFilterTitle1Subtitle:"(aw 0,1 a 0,5)",
    absorptionIdFilterTitle2:"Fuerte",
    absorptionIdFilterTitle2Subtitle:"(aw 0,5 a 0,75)",
    absorptionIdFilterTitle3:"Fuerte +",
    absorptionIdFilterTitle3Subtitle:"(aw 0,75 a 0,95)",

    acousticPerformanceButton:"Ensayo acústico",
    acousticPerformanceLabel:"Rendimiento acústico:",
    PerforationRateLabel:"Tasa de perforación:",
    acousticPerformanceComingSoon:"Ensayo acústico disponible pronto",


    validateButton:"Validar",
    validationMessage:"Su modificación ha sido guardada."
  }
};

/*
bbbb: {
  aaa:"",
  aaa:"",
  aaa:"",
  aaa:""
}

*/



// WEBPACK FOOTER //
// ./src/i18n/es.js